// import LocomotiveScroll from "locomotive-scroll";
import { useEffect } from "react";
import Rellax from "rellax";
import { isEmpty } from "lodash";

// Configuración para parallax de movimiento del ratón
export const parallaxMouseMovement = () => {
  if (typeof window !== "undefined") {
    document.querySelectorAll(".parallax-mousemove-scene").forEach((scene) => {
      scene.addEventListener("mousemove", (e) => {
        const w = window.innerWidth;
        const h = window.innerHeight;
        const offsetX = 0.5 - (e.pageX - scene.offsetLeft) / w;
        const offsetY = 0.5 - (e.pageY - scene.offsetTop) / h;

        scene.querySelectorAll(".parallax-mousemove").forEach((el) => {
          const offset = parseInt(el.getAttribute("data-offset"));
          el.style.transform = `translate3d(${Math.round(offsetX * offset)}px, ${Math.round(offsetY * offset)}px, 0px)`;
        });

        scene.querySelectorAll(".parallax-mousemove-follow").forEach((el) => {
          el.style.left = `${e.pageX - scene.offsetLeft}px`;
          el.style.top = `${e.pageY - scene.offsetTop}px`;
        });
      });

      scene.addEventListener("mouseenter", () => {
        scene.querySelectorAll(".parallax-mousemove-follow").forEach((el) => {
          el.style.transition = "all .27s ease-out";
          el.style.willChange = "transform";
        });
      });

      scene.addEventListener("mouseout", () => {
        scene.querySelectorAll(".parallax-mousemove-follow").forEach((el) => {
          el.style.transition = "none";
        });
      });
    });
  }
};

// export function useParallaxScroll() {
//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       const scrollContainer = document.querySelector("[data-scroll-container]");

//       const locomotiveScroll = new LocomotiveScroll({
//         el: scrollContainer,
//         smooth: true,            // Activa el desplazamiento suave
//         multiplier: 0.8,         // Ajusta la velocidad del desplazamiento
//         class: "is-in-view",     // Clase añadida a los elementos visibles
//         lerp: 0.1,               // Define la suavidad de desplazamiento (mayor valor = más suave)
//       });

//       // Añade un listener de resize solo para actualizar en caso de redimensionamiento
//       window.addEventListener("resize", () => {
//         locomotiveScroll.update();
//       });

//       // Limpia la instancia y los listeners cuando el componente se desmonta
//       return () => {
//         locomotiveScroll.destroy();
//         window.removeEventListener("resize", locomotiveScroll.update);
//       };
//     }
//   }, []);
// }

export function useRellaxParallax() {
  useEffect(() => {
    if (window.innerWidth <= 1024) return;

    let rellaxYInstance = null;
    let rellaxXInstance = null;
    let handleScroll = null;

    const observer = new MutationObserver((mutations, observerInstance) => {
      const rellaxYElements = document.querySelectorAll("[data-rellax-y]");
      const rellaxXElements = document.querySelectorAll("[data-rellax-x]");

      if (rellaxYElements.length || rellaxXElements.length) {
        rellaxYInstance = new Rellax("[data-rellax-y]", {
          vertical: true,
          horizontal: false,
        });

        rellaxXInstance = new Rellax("[data-rellax-x]", {
          horizontal: true,
          vertical: false,
        });

        handleScroll = () => {
          [...rellaxYElements, ...rellaxXElements].forEach((element) => {
            const rect = element.getBoundingClientRect();
            if (rect.top < window.innerHeight && rect.bottom > 0) {
              element.classList.add("js-in-viewport");
              !isEmpty(rellaxYInstance) && rellaxYInstance.refresh();
              !isEmpty(rellaxXInstance) && rellaxXInstance?.refresh();
            } else {
              element.classList.remove("js-in-viewport");
            }
          });
        };

        window.addEventListener("scroll", handleScroll);
        observerInstance.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      if (handleScroll) window.removeEventListener("scroll", handleScroll);
      if (!isEmpty(rellaxYInstance)) rellaxYInstance.destroy();
      if (!isEmpty(rellaxXInstance)) rellaxXInstance.destroy();
    };
  }, []);
}